"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var document_search_helper_1 = require("../../util/document-search-helper");
var DocumentMetaDataFilterComponent = /** @class */ (function () {
    function DocumentMetaDataFilterComponent(_classifierService, languageService, currentLanguageProvider) {
        this._classifierService = _classifierService;
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.MetaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        this.filter = new core_1.EventEmitter();
        this._isReady = false;
        this._values = null;
        this._destroy$ = new Subject_1.Subject();
    }
    DocumentMetaDataFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (data) {
            _this._currentLanguageId = data.getId();
            _this._isReady = true;
        }), operators_1.takeUntil(this._destroy$)).subscribe();
    };
    DocumentMetaDataFilterComponent.prototype.onValuesChange = function (value) {
        this._values = value;
        this.filter.emit(value ? document_search_helper_1.DocumentSearchHelper.constructMetaDataFilterCriteria("" + this.key, this.fieldType, this.values) : undefined);
    };
    DocumentMetaDataFilterComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    Object.defineProperty(DocumentMetaDataFilterComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentMetaDataFilterComponent.prototype, "values", {
        get: function () {
            return this._values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentMetaDataFilterComponent.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentMetaDataFilterComponent.prototype, "key", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DocumentMetaDataFilterComponent.prototype, "fieldType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentMetaDataFilterComponent.prototype, "displayNameMsgId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentMetaDataFilterComponent.prototype, "classifierValues", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentMetaDataFilterComponent.prototype, "inMain", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DocumentMetaDataFilterComponent.prototype, "filter", void 0);
    DocumentMetaDataFilterComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-document-meta-data-filter',
            styles: [require('./document-meta-data-filter.component.css')],
            template: require('./document-meta-data-filter.component.html')
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], DocumentMetaDataFilterComponent);
    return DocumentMetaDataFilterComponent;
}());
exports.DocumentMetaDataFilterComponent = DocumentMetaDataFilterComponent;
//# sourceMappingURL=document-meta-data-filter.component.js.map